export class ConsignmentUtils {
    static isOnMarketplace = (consignment) => {
        if (consignment
            && consignment.paymentMethod
            && consignment.totalPaymentAmount) {
            return true;
        }
        return !!((consignment
            && consignment.marketplaceListings)
            && consignment.marketplaceListings.length);
    };
}
